import { useEffect, useState} from 'react';
import axios from 'axios';
import { ENTRYPOINT } from "../helper/entrypoint";

const useFetchReview = (token) => {
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: response } = await axios.get(`${ENTRYPOINT}/public/review_codes/${token}`);
        setData(response);
      } catch (error) {
        console.error(error)
        setError(error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  return {
    data,
    error,
    loading,
  };
};

export default useFetchReview;